<template>
    <div class="columnarEcharts">
        <div :id="echarts" :style="{width: '100%', 'height': height}"></div>
    </div>
</template>

<script>
    var echarts = require('echarts');
    export default {
        name: "contrast",
        props: {
            height: {
                type: String,
                default: '486px'
            },
            barWidth:{
                type: Number,
                default: 34
            },
            seriesData:{
                type:Object,
                default() {
                    return { title:'',xAxisData:[],yAxisName:'',estimateData:[],actualData:[],legendData:[] }
                }
            }
        },
        data(){
            return{

            }
        },
        methods:{
            drawColumnar(){
                let color1 = new echarts.graphic.LinearGradient(0, 0, 0, 1,[{ offset: 0, color: "#4C83FF" }, { offset: 1, color: "#2AFADF" }],false);
                let color2 = new echarts.graphic.LinearGradient(0, 0, 0, 1,[{ offset: 0, color: "#FF3F5F" }, { offset: 1, color: "#F4A7A1" }],false);
                let myChart = echarts.init(document.getElementById(this.echarts));
                let option = {
                    title: {
                        text: this.seriesData.title,
                        left: '-5',
                        top: '0',
                        textStyle: {
                            color: '#fff',
                            fontSize: 18,
                            align: 'center'
                        }
                    },
                    grid: {
                        top: '15%',
                        left: '6%',
                        right: '0',
                        bottom:'10px',
                        containLabel: true
                    },
                    legend: {
                        textStyle: {
                            color: '#fff',
                            width: 240,
                            fontSize: '14'
                        },
                        itemGap: 24, // 设置legend的间距
                        itemWidth: 20, // 设置宽度
                        itemHeight: 20, // 设置高度
                        top:'40px',
                        right:'0',
                        data: this.seriesData.legendData
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    xAxis: {
                        type: 'category',
                        axisLabel:{
                            textStyle:{
                                color:'#fff'
                            }
                        },
                        data: this.seriesData.xAxisData
                    },
                    yAxis: {
                        name: this.seriesData.yAxisName,
                        type: 'value',
                        axisLine: {show:true},
                        splitLine: {
                            show: false,
                            lineStyle: {
                                type: 'dashed'
                            }
                        },
                        axisLabel:{
                            textStyle:{
                                color:'#fff'
                            }
                        },
                        nameLocation:'end',
                        nameTextStyle:{
                            color:"#fff",
                            fontSize:11,
                            padding:[0, 50, 0, 0]
                        },
                    },
                    color: [color1, color2],
                    series: [
                        {
                            name:'预计投入',
                            //类型：折线图
                            type:'bar',
                            barGap: 0,
                            barWidth : 34,
                            itemStyle: {
                                normal: {
                                    //柱形图圆角，初始化效果
                                    barBorderRadius: [89, 89, 0, 0],
                                }
                            },
                            data:this.seriesData.estimateData
                        },
                        {
                            name:'实际投入',
                            //类型：折线图
                            type:'bar',
                            barGap: 0,
                            barWidth : 34,
                            itemStyle: {
                                normal: {
                                    //柱形图圆角，初始化效果
                                    barBorderRadius: [89, 89, 0, 0],
                                }
                            },
                            data:this.seriesData.actualData
                        }
                    ]
                };
                myChart.setOption(option);
            },
        },
        watch: {
            seriesData: {
                deep: true,
                handler: () => this.seriesData
            }
        },
        mounted() {
            this.drawColumnar();
            window.addEventListener("resize", this.drawColumnar);

        },
        beforeDestroy() {
            window.removeEventListener("resize", this.drawColumnar);
        },
        computed: {
            echarts() {
                return 'echarts' + Math.random() * 100000;
            }
        },
    }
</script>

<style scoped>

</style>
